import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useRef } from "react";
import {
  UpdateProfileImage,
  updateAccountDetails,
} from "../../service/apis/auth.api";
import { setUser } from "../../store/auth.store";
import { useFormik } from "formik";
import * as yup from "yup";
import { ValidationCons } from "../../validation/validationConstant";
import { showError, showSuccess } from "../../utils/Common";
import UserProfileNoImg from "@/../../public/images/no-image.jpg";

const EmpAccountDetailsScreen = () => {
  const dispatch = useDispatch();

  const [showprofile, setShowEditPersonalInformation] = useState(false);
  const handleClose = () => setShowEditPersonalInformation(false);
  const handleShow = () => setShowEditPersonalInformation(true);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [, setCompanyLogo] = useState<File | null>(null);

  const [, setLoading] = useState<boolean>(false);

  const { user } = useSelector(
    (state: RootState) => state.authSlice
  );

  const updateProfileik = useFormik({
    initialValues: {
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      emailAddress: user?.email || "",
      phone: user?.phone || "",
      companyName: user?.externalInfo?.name || "",
    },
    validationSchema: yup.object({
      firstName: yup
        .string()
        .trim()
        .required(ValidationCons.FIRST_NAME_REQUIRED),
      lastName: yup.string().trim().required(ValidationCons.LAST_NAME_REQUIRED),
      emailAddress: yup
        .string()
        .email(ValidationCons.IS_EMAIL)
        .required(ValidationCons.EMAIL_REQUIRED),
      phone: yup
        .string()
        .matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, ValidationCons.VALID_PHONE)
        .min(10, ValidationCons.VALID_PHONE)
        .max(15, ValidationCons.VALID_PHONE),

      companyName: yup
        .string()
        .trim()
        .required(ValidationCons.COMPANY_REQUIRED),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);

      try {
        let bodyData = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.emailAddress,
          phone: values.phone,
          "externalInfo[name]": values.companyName,
        };

        const response = await updateAccountDetails(bodyData);
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleClose();
            dispatch(setUser(response.user));
            showSuccess("Profile Updated successfully");

          }
        }
      } catch (error) {
        setLoading(false);
        showError(error);
      }
    },
  });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFile(file);
      setCompanyLogo(file);
      const reader = new FileReader();
      reader.onload = () => setSelectedImage(reader.result as string);
      reader.readAsDataURL(file);
    }
  };

  const handleImageUpload = async () => {
    if (file) {
      // Logic to upload the file to the server

      const formData = new FormData();
      formData.append("profileimageurl", file);
      const response = await UpdateProfileImage(formData);
      dispatch(setUser(response.user));
      showSuccess("Profile Image Updated successfully");
      setFile(null);
    }
  };

  // Inside your component
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Programmatically trigger the input click
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar position-relative p-0">
                <EmployerSidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <EmployerHeaderScreen />
                <div className="profile-account-details-holder rightInnerScroll common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Account</h2>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="comnbrdrGap  profile-image">
                              <div className="profile-image-img">
                                <img
                                  src={
                                    selectedImage || user?.profileimageurl
                                      ? user?.profileimageurl
                                      : UserProfileNoImg
                                  }
                                  alt="profile"
                                />
                              </div>
                              <h4>
                                {
                                  user?.externalInfo?.name &&
                                  <>
                                    <span>Company Name</span>
                                    {user?.externalInfo?.name}{" "}
                                  </>
                                }
                              </h4>
                              <input
                                type="file"
                                accept="image/*"
                                name="companyLogo"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                ref={fileInputRef}
                              />
                              {!file && (
                                <Button onClick={handleImageClick}>
                                  Change Image
                                </Button>
                              )}
                              {file && (
                                <Button onClick={handleImageUpload}>
                                  Upload Image
                                </Button>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-9">
                            <div className="comnbrdrGap profileEdit mb-4">
                              <div className="d-flex">
                                <h3>Personal Information</h3>
                                <button
                                  className="editbtn"
                                  onClick={handleShow}
                                >
                                  <LuPencilLine /> Edit
                                </button>
                              </div>
                              <div className="row">
                                <div className="col-lg-4">
                                  <p>Name</p>
                                  <h6>
                                    {user?.firstName} {user?.lastName}
                                  </h6>
                                </div>
                                <div className="col-lg-4">
                                  <p>Email Address</p>
                                  <h6>{user?.email}</h6>
                                </div>
                                <div className="col-lg-4">
                                  <p>Company Name</p>
                                  <h6>{user?.externalInfo?.name}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* Edit Personal Information model*/}
      <Modal
        show={showprofile}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Edit Personal Information</h3>
            <Form
              className="modalSearch"
              onSubmit={updateProfileik.handleSubmit}
            >
              <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={`${user?.firstName}`}
                  name="firstName"
                  onChange={updateProfileik.handleChange}
                  onBlur={updateProfileik.handleBlur}
                  value={updateProfileik.values.firstName}
                  isInvalid={
                    !!updateProfileik.errors.firstName &&
                    Boolean(updateProfileik.touched.firstName)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof updateProfileik.errors.firstName === "string" &&
                    updateProfileik.errors.firstName}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={`${user?.lastName}`}
                  name="lastName"
                  onChange={updateProfileik.handleChange}
                  onBlur={updateProfileik.handleBlur}
                  value={updateProfileik.values.lastName}
                  isInvalid={
                    !!updateProfileik.errors.lastName &&
                    Boolean(updateProfileik.touched.lastName)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof updateProfileik.errors.lastName === "string" &&
                    updateProfileik.errors.lastName}
                </Form.Control.Feedback>
              </Form.Group>
              {/* <Form.Group className="mb-3">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control type="email" placeholder={updateProfileik.values.emailAddress} 
                                name="emailAddress"
                                onChange={updateProfileik.handleChange}
                                onBlur={updateProfileik.handleBlur} 
                                value={updateProfileik.values.emailAddress}
                                isInvalid={
                                !!updateProfileik.errors.emailAddress && 
                                Boolean(updateProfileik.touched.emailAddress)} readOnly/>

                                <Form.Control.Feedback type="invalid">
                                    {typeof updateProfileik.errors.emailAddress === "string" && updateProfileik.errors.emailAddress}
                                </Form.Control.Feedback>
                            </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control type="text" placeholder="Enter company name"
                  name="companyName"
                  onChange={updateProfileik.handleChange}
                  onBlur={updateProfileik.handleBlur}
                  value={updateProfileik.values.companyName}
                  isInvalid={
                    !!updateProfileik.errors.companyName &&
                    Boolean(updateProfileik.touched.companyName)} />

                <Form.Control.Feedback type="invalid">
                  {typeof updateProfileik.errors.companyName === "string" && updateProfileik.errors.companyName}
                </Form.Control.Feedback>
              </Form.Group>

              {/* <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="(555) 123-4567"
                  name="phone"
                  onChange={updateProfileik.handleChange}
                  onBlur={updateProfileik.handleBlur}
                  value={updateProfileik.values.phone}
                  isInvalid={
                    !!updateProfileik.errors.phone &&
                    Boolean(updateProfileik.touched.phone)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof updateProfileik.errors.phone === "string" &&
                    updateProfileik.errors.phone}
                </Form.Control.Feedback>
              </Form.Group> */}
              <Button className="btn w-100" type="submit">
                Save
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Edit Personal Information model*/}
    </>
  );
};
export default EmpAccountDetailsScreen;
